import { SharedModule } from './../shared/shared.module';
import { CommonModule } from '@angular/common';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PocComponent } from './poc/poc.component';
import { VisaDesignerRoutingModule } from './visa-designer-routing.module';
import { DynamicFormBuilderModule } from '../dynamic-form-builder/dynamic-form-builder.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { VdContainerComponent } from './vd-container/vd-container.component';
import { VdCreatedListComponent } from './vd-created-list/vd-created-list.component';
import { VdStandardListComponent } from './vd-standard-list/vd-standard-list.component';
import { VdListFiltersComponent } from './vd-list-filters/vd-list-filters.component';
import { VdVisaContainerComponent } from './vd-visa-container/vd-visa-container.component';
import { VdVisaCreationComponent } from './vd-visa-creation/vd-visa-creation.component';
import { VdBuilderContainerComponent } from './vd-builder-container/vd-builder-container.component';
import { VdBuilderStepsNavigatorComponent } from './vd-builder-steps-navigator/vd-builder-steps-navigator.component';
import { VdBuilderPlaceholderContainerComponent } from './vd-builder-placeholder-container/vd-builder-placeholder-container.component';
import { VdBuilderTaskSectionComponent } from './vd-builder-task-section/vd-builder-task-section.component';
import { VdBuilderLettersSectionComponent } from './vd-builder-letters-section/vd-builder-letters-section.component';
import { VdBuilderPreviewComponent } from './vd-builder-preview/vd-builder-preview.component';
import { VdBuilderReviewComponent } from './vd-builder-review/vd-builder-review.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { PrimengLibraryModule } from 'primeng-library';
import { VdBuilderTimelineStepsComponent } from './vd-builder-timeline-steps/vd-builder-timeline-steps.component';
import { VdBuilderDroppableContentPanelComponent } from './vd-builder-droppable-content-panel/vd-builder-droppable-content-panel.component';
import { FeeCalculationLibraryModule } from 'fee-calculation-library';
import { MatMenuModule } from '@angular/material/menu';
// import { TaskDetailsModule } from 'task-details';
import { EmailAddressComponent } from '../../modules/common-component/email-address/email-address.component';
import { AddressDetailsComponent } from '../../modules/common-component/address-details/address-details.component';
import { ComponentLoaderComponent } from './component-loader/component-loader-component';
import { VdGenerateLettersComponent } from './vd-generate-letters/vd-generate-letters.component';
import { VdLettersElementsComponent } from './vd-letters-elements/vd-letters-elements.component';
import { VdDefaultTemplateComponent } from './vd-default-template/vd-default-template.component';
import { TaskDetailsModule } from 'task-details';
import { CommonQuetionsModule } from 'common-quetions';
import { ClipboardModule } from 'ngx-clipboard';

//import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
//import 'froala-editor/js/plugins.pkgd.min.js';
import { CustomTextFieldModule } from 'custom-text-field';
import { CustomRadioButtonModule } from 'custom-radio-button';
import { CustomFormRadioButtonModule } from 'custom-form-radio-button';
import { VdBuilderPreviewStepsComponent } from './vd-builder-preview-steps/vd-builder-preview-steps.component';
import { CreateTaskActionsModule } from 'create-task-actions';
import { VdBuilderTimelineCreateStepsComponent } from './vd-builder-timeline-create-steps/vd-builder-timeline-create-steps.component';
import { CustomCheckboxModule } from 'custom-checkbox';
import { CustomDropdownModule } from 'custom-dropdown';
import { CustomCalenderModule } from 'custom-calender';
import { CustomChipModule } from 'custom-chip';
import { CustomButtonModule } from 'custom-button';
import { FileUploadLibraryModule } from 'file-upload-library';
import { DialogService } from 'primeng/dynamicdialog';
import { CommonEditorModule } from 'common-editor';
import { VdCustomFileUploadModule } from 'vd-custom-file-upload';
import { SubTaskExtraOrdinaryAbilityModule } from 'sub-task-extra-ordinary-ability';
// import {DragDropModule} from 'primeng/dragdrop';
import { CreateTaskLibraryModule } from 'create-task-library';
// import { JobDutiesModule } from 'job-duties';
import { VdSwitchGroupModule } from 'vd-switch-group';
import { StepStatusUpdateComponentLibraryModule } from 'step-status-update-component-library';
import { JobDutiesLibraryModule } from 'job-duties-library';

import { VdDividerModule } from 'vd-divider';
import { VdLabelModule } from 'vd-label';
import { CustomQuestionsGroupModule } from 'custom-questions-group';
import { VdTextAreaModule } from 'vd-text-area';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { VdStepsFormPreviewComponent } from './vd-steps-form-preview/vd-steps-form-preview.component';
import { SubTaskPetitionDetailsModule } from 'sub-task-petition-details';
import { CustomGridEditorLibraryModule } from 'custom-grid-editor-library';
// import { CustomCheckboxModule } from 'projects/custom-checkbox/src/lib/custom-checkbox.module';
import { VdBuilderFormMappingComponent } from './vd-builder-form-mapping/vd-builder-form-mapping';
import { VdPhoneModule } from 'vd-phone'
import { FieldsetModule } from 'primeng/fieldset';
import { VdSubTaskH4Module } from 'vd-sub-task-h4';
import { VdConfigPetitionSubTaskModule } from 'vd-config-petition-sub-task';
import { VdH4TaskDetailsModule } from 'vd-h4-task-details';
import { VdEadLibraryModule } from 'vd-ead-library';
import { VdAddressModule } from 'vd-address';
import { VdAddGenerateFormModule } from 'vd-add-generate-form';
import { VdBuilderBuildStepsComponent } from './vd-builder-build-steps/vd-builder-build-steps.component';
import { BuildVisaDesignerComponent } from './build-visa-designer/build-visa-designer.component';
import { StoreModule } from '@ngrx/store';
import { vdReducer } from './vd-state/reducers/vd.reducer';
import { UploadPdfComponent } from './upload-pdf/upload-pdf.component';
import { VdCountryStateModule } from 'vd-country-state';
import { MoveToStepComponent } from './move-to-step/move-to-step.component';
import { EditorModule } from '@progress/kendo-angular-editor';
import { PdfStepPreviewComponent } from './pdf-step-preview/pdf-step-preview.component';
import { CustomKendoModule } from '../custom-kendo/custom-kendo.module';
import { VdJsonViewerComponent } from './vd-json-viewer/vd-json-viewer.component';
import { VdCountModule } from 'vd-count';

import { CustomButtonActionModule } from 'custom-button-action';

@NgModule({
  declarations: [
    PocComponent,
    VdContainerComponent,
    VdCreatedListComponent,
    VdStandardListComponent,
    VdListFiltersComponent,
    VdVisaContainerComponent,
    VdVisaCreationComponent,
    VdBuilderContainerComponent,
    VdBuilderStepsNavigatorComponent,
    VdBuilderPlaceholderContainerComponent,
    VdBuilderTaskSectionComponent,
    VdBuilderLettersSectionComponent,
    VdBuilderPreviewComponent,
    VdBuilderReviewComponent,
    VdBuilderTimelineStepsComponent,
    VdBuilderDroppableContentPanelComponent,
    VdGenerateLettersComponent,
    VdLettersElementsComponent,
    EmailAddressComponent,
    AddressDetailsComponent,
    ComponentLoaderComponent,
    VdDefaultTemplateComponent,
    VdBuilderPreviewStepsComponent,
    VdBuilderTimelineCreateStepsComponent,
    VdStepsFormPreviewComponent,
    VdBuilderFormMappingComponent,
    VdBuilderBuildStepsComponent,
    BuildVisaDesignerComponent,
    UploadPdfComponent,
    MoveToStepComponent,
    PdfStepPreviewComponent,
    VdJsonViewerComponent,
  ],
  imports: [
    CommonModule,
    ClipboardModule,
    VisaDesignerRoutingModule,
    DynamicFormBuilderModule,
    FormsModule,
    ReactiveFormsModule,
    DragDropModule,
    GooglePlaceModule,
    MatIconModule,
    MatButtonModule,
    MatDividerModule,
    PrimengLibraryModule,
    FeeCalculationLibraryModule,
    MatMenuModule,
    TaskDetailsModule,
    SubTaskPetitionDetailsModule,
    CommonQuetionsModule,
    // FroalaEditorModule.forRoot(), FroalaViewModule.forRoot(),
    CustomTextFieldModule,
    CustomRadioButtonModule,
    CustomFormRadioButtonModule,
    CreateTaskActionsModule,
    CustomCheckboxModule,
    CustomDropdownModule,
    CustomCalenderModule,
    CustomButtonActionModule,
    CustomChipModule,
    CustomButtonModule,
    VdCustomFileUploadModule,
    CommonEditorModule,
    CreateTaskLibraryModule,
    SubTaskExtraOrdinaryAbilityModule,
    JobDutiesLibraryModule,
    VdSwitchGroupModule,
    StepStatusUpdateComponentLibraryModule,
    VdDividerModule,
    VdLabelModule,
    VdTextAreaModule,
    PdfViewerModule,
    CustomQuestionsGroupModule,
    CustomGridEditorLibraryModule,
    FieldsetModule,
    VdPhoneModule,
    VdSubTaskH4Module,
    VdConfigPetitionSubTaskModule,
    VdH4TaskDetailsModule,
    VdEadLibraryModule,
    VdAddressModule,
    EditorModule,
    VdAddGenerateFormModule,
    StoreModule.forFeature('vd', vdReducer),
    VdCountryStateModule,
    CustomKendoModule,
    VdCountModule,
    SharedModule
  ],
  exports: [
    ComponentLoaderComponent
  ],
  providers: [
    DialogService
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ],
  entryComponents: [
    BuildVisaDesignerComponent,
    MoveToStepComponent
  ]
})
export class VisaDesignerModule { }
